import { Injectable } from "@angular/core";
import { Procedure } from "../../models/Procedure";

@Injectable({
    providedIn: 'root'
})
export class ProcedureService {

    constructor() {
    }

    public getProcedure(controls): Procedure {

        const procedure = new Procedure();
        procedure.appelOuvert = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_appelOuvert')
        procedure.concoursOuvert = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_concoursOuvert')
        procedure.dialogueCompetitif = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_dialogueCompetitif')
        procedure.concoursRestreint = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_concoursRestreint')
        procedure.appelRestreint = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_appelRestreint')
        procedure.procedureAdaptee = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_procedureAdaptee')
        procedure.autres = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_autres')
        procedure.marcheNegocie = controls.get('_SepSep_Annulation_SepSep_Procedure_SepAtt_marcheNegocie')
        
        return procedure;
    }
}